<template>
  <div class="timeline-calendar__row">
    <div
      v-for="day in days"
      class="timeline-calendar__days timeline-calendar__item"
      :data-grid-columns="1"
    >
      {{ new Date(day).getDate() }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const model = defineModel({
  type: Object,
  required: true,
  default: () => ({}),
});

const days = computed(() => model.value.grid.value.days);
</script>
